import { render, staticRenderFns } from "./PheDuyetBtn.vue?vue&type=template&id=43a47a38&"
import script from "./PheDuyetBtn.vue?vue&type=script&lang=js&"
export * from "./PheDuyetBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports